module.exports = __webpack_public_path__ + "static/img/p1.550c731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/p1.png
// module id = 3ieq
// module chunks = 0